import { render, staticRenderFns } from "./MdSignatureCaptureCN.vue?vue&type=template&id=1f33978e&"
import script from "./MdSignatureCaptureCN.vue?vue&type=script&lang=js&"
export * from "./MdSignatureCaptureCN.vue?vue&type=script&lang=js&"
import style0 from "./MdSignatureCaptureCN.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports